import { render, staticRenderFns } from "./lgexperiencia.vue?vue&type=template&id=3db2995e&"
import script from "./lgexperiencia.vue?vue&type=script&lang=js&"
export * from "./lgexperiencia.vue?vue&type=script&lang=js&"
import style0 from "./lgexperiencia.vue?vue&type=style&index=0&id=3db2995e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports